import React from "react";
import { Layout } from "antd";
import { HierarchyContainer } from "./HierarchyContainer";
import { AddHierarchyContainer } from "./AddHierarchyContainer";

const { Content, Sider } = Layout;
export const MonthlySettingsBaseView = () => {
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={550}
            style={{
              background: "#fff",
              paddingLeft: "10px",

              paddingTop: "10px",
            }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <HierarchyContainer />
                </div>
              </div>
            </div>
          </Sider>
          <Content>
            <AddHierarchyContainer />
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

